import { type ComponentProps } from 'react';

import { Badge } from '@/components/Badge/Badge';
import { statusLabel, statusVariant } from '@/components/Badge/statuses';

type StatusBadgeProps = Omit<ComponentProps<typeof Badge>, 'variant' | 'children'> & {
    /** One of the Status reference's display labels, e.g. "Not paid". */
    status: string;
};

/** A badge that cannot pick the wrong colour: the status decides the variant and the label. */
function StatusBadge({ status, ...props }: StatusBadgeProps) {
    return (
        <Badge
            data-slot="status-badge"
            data-status={status}
            variant={statusVariant(status)}
            {...props}
        >
            {statusLabel(status)}
        </Badge>
    );
}

export { StatusBadge, type StatusBadgeProps };
